import { render, staticRenderFns } from "./TableApp.vue?vue&type=template&id=114bd358"
import script from "./TableApp.vue?vue&type=script&lang=js"
export * from "./TableApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports